import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            clipRule="evenodd"
            d="M5.25006 12.75C4.83585 12.75 4.50006 12.4142 4.50006 12C4.50006 7.93786 7.67432 4.66403 11.6954 4.50598L10.7197 3.53033C10.4268 3.23744 10.4268 2.76256 10.7197 2.46967C11.0126 2.17678 11.4875 2.17678 11.7804 2.46967L13.9597 4.64896C14.2916 4.98091 14.2916 5.51909 13.9597 5.85104L11.7804 8.03033C11.4875 8.32322 11.0126 8.32322 10.7197 8.03033C10.4268 7.73744 10.4268 7.26256 10.7197 6.96967L11.6812 6.00816C8.49612 6.17159 6.00006 8.7712 6.00006 12C6.00006 12.4142 5.66427 12.75 5.25006 12.75ZM18.7499 11.25C19.1642 11.25 19.4999 11.5858 19.4999 12C19.4999 16.0621 16.3257 19.336 12.3046 19.494L13.2803 20.4697C13.5732 20.7626 13.5732 21.2374 13.2803 21.5303C12.9874 21.8232 12.5125 21.8232 12.2196 21.5303L10.0403 19.351C9.70838 19.0191 9.70838 18.4809 10.0403 18.149L12.2196 15.9697C12.5125 15.6768 12.9874 15.6768 13.2803 15.9697C13.5732 16.2626 13.5732 16.7374 13.2803 17.0303L12.3188 17.9918C15.5039 17.8284 17.9999 15.2288 17.9999 12C17.9999 11.5858 18.3357 11.25 18.7499 11.25Z"
            fill="currentColor"
            fillRule="evenodd"
        />
    </svg>
);

export default Icon;
